

export default {
  methods: {
    showCreateMessage () {
      this.$toasted.global.defaultSuccess('Cadastro realizado com Sucesso!');
    },
    showUpdateMessage () {
      this.$toasted.global.defaultSuccess('Atulização realizada com Sucesso!');
    },
    showErrorMessage ({graphQLErrors}) {
      const erro = graphQLErrors.map(({extensions }) => {
          if(extensions.validation){
              if(extensions.validation.email){
                return extensions.validation.email[0]
              }else if(extensions.validation.alias){
                return extensions.validation.alias[0]
              }else if(extensions.validation.name){
                return extensions.validation.name[0]
              }
          }

        }
      )
      this.$toasted.global.defaultError(erro)
    }
  }
}